import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Reset scroll to the top on every route change. */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
